import { render, staticRenderFns } from "./AditiveData.vue?vue&type=template&id=4bb7a858&scoped=true&"
import script from "./AditiveData.vue?vue&type=script&lang=ts&"
export * from "./AditiveData.vue?vue&type=script&lang=ts&"
import style0 from "./AditiveData.vue?vue&type=style&index=0&id=4bb7a858&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb7a858",
  null
  
)

export default component.exports